
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { makeAuthenticatedRequest } from "../utils/apiRequest";
import { useAuth } from "../contexts/authContext";

const CheckInCheckOutPopup = ({ onClose, onAdd, defaultCity, editMode, editData, popupTitle, selectedRoomCategory,   }) => {

  
  const [availableCities, setAvailableCities] = useState([]);
  const [availableHotels, setAvailableHotels] = useState([]);
  const [selectedCity, setSelectedCity] = useState(defaultCity || "");
  const [selectedHotel, setSelectedHotel] = useState("");
  const [mealPlan, setMealPlan] = useState("B/B");
  const [inclusion, setInclusion] = useState(
    editData?.inclusion === false || editData?.inclusion === "False" ? false : true
  );
  
  const [arrangement, setArrangement] = useState("Company Arrangement"); // Default arrangement
  const [isLoadingCities, setIsLoadingCities] = useState(false);
  const [isLoadingHotels, setIsLoadingHotels] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { token, currentUser } = useAuth();
  const [mealPlans, setMealPlans] = useState([]); // State to store meal plans

  const [roomType, setRoomType] = useState();
const [roomTypes, setRoomTypes] = useState([]); // State for available room types


  useEffect(() => {
    console.log("Default city passed to popup:", defaultCity);
    console.log("Selected city state on mount:", selectedCity);
  }, [defaultCity, selectedCity]);

  useEffect(() => {
    if (editMode && editData) {
      setSelectedCity(editData.city || defaultCity || "");
      setSelectedHotel(editData.hotel_name || "");
      setMealPlan(editData.mealPlan || "B/B");
      setArrangement(editData.arrangement || "Company Arrangement");
      setInclusion(editData.inclusion !== undefined ? editData.inclusion : true);
      setRoomType(editData.roomType || editData.roomCategory || selectedRoomCategory || "");
  
      if (editData.hotel_name) {
        fetchHotels(editData.city); // Ensure room types are fetched for the selected hotel
      }
    }
  }, [editMode, editData, defaultCity, selectedRoomCategory]);
  
  
  
  

  const fetchCities = async () => {
    if (!token) {
      setError("Authorization token is missing.");
      return;
    }

    setIsLoadingCities(true);
    setError(null);

    try {
      const response = await makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_cities",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error fetching cities: ${response.statusText}`);
      }

      const data = await response.json();
      setAvailableCities(data.data || []);
    } catch (err) {
      setError("Failed to fetch cities.");
    } finally {
      setIsLoadingCities(false);
    }
  };

  const fetchHotels = async (city) => {
    if (!token) {
      setError("Authorization token is missing.");
      return;
    }
  
    setIsLoadingHotels(true);
    setError(null);
  
    try {
      const response = await fetch(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_hotel_location_data",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ city_name: [city] }),
        }
      );
  
      if (!response.ok) {
        throw new Error(`Error fetching hotels: ${response.statusText}`);
      }
  
      const data = await response.json();
      // Sort hotels alphabetically by name before setting state
      const sortedHotels = (data.data.hotels || []).sort((a, b) => a.name.localeCompare(b.name));
      setAvailableHotels(sortedHotels);
  
      // If edit mode and editData exist, fetch meal plans
      if (editMode && editData?.hotel_name) {
        const selectedHotelData = data.data.hotels.find(hotel => hotel.name === editData.hotel_name);
        
        if (selectedHotelData) {
          const mealPlansList = Object.entries(selectedHotelData.types || {})
            .filter(([plan, isAvailable]) => isAvailable)
            .map(([plan]) => plan);
  
          setMealPlans(mealPlansList);
        }
      }
    } catch (err) {
      setError("Failed to fetch hotels.");
    } finally {
      setIsLoadingHotels(false);
    }
  };
  
  
  const handleHotelSelect = (hotelName) => {
    setSelectedHotel(hotelName);
  
    // Find the selected hotel data
    const selectedHotelData = availableHotels.find(
      (hotel) => hotel.name === hotelName
    );
  
    // Update room types for the selected hotel
    if (selectedHotelData) {
      setRoomTypes(selectedHotelData.room_types || []); // Set room types for the selected hotel
    } else {
      setRoomTypes([]); // Reset room types if no hotel is selected
    }
  
    // Optionally update meal plans based on the selected hotel
    const trueMealPlans = Object.entries(selectedHotelData?.types || {})
      .filter(([plan, isAvailable]) => isAvailable)
      .map(([plan]) => plan);
    setMealPlans(trueMealPlans);
  };
  
  useEffect(() => {
    if (selectedHotel) {
      // Update room types for the selected hotel
      const selectedHotelData = availableHotels.find(hotel => hotel.name === selectedHotel);
      setRoomTypes(selectedHotelData?.room_types || []);
    }
  }, [selectedHotel, availableHotels]); // Runs when hotel or availableHotels changes

  

  useEffect(() => {
    if (selectedRoomCategory && roomTypes.includes(selectedRoomCategory)) {
      setRoomType(selectedRoomCategory); // Set roomType when selectedRoomCategory is received
    }
  }, [selectedRoomCategory, roomTypes]);  // Runs when selectedRoomCategory or roomTypes changes
  

  
  
  
  
  
  
  
  useEffect(() => {
    fetchCities();
  }, []);

  useEffect(() => {
    if (selectedCity) {
      fetchHotels(selectedCity);
    }
  }, [selectedCity]);
  const handleAddCheckInCheckOut = () => {
    if (!selectedHotel || !mealPlan || !roomType) {
      alert("Please select hotel name, meal plan, and room type.");
      return;
    }
  
    const selectedHotelData = availableHotels.find(
      (hotel) => hotel.name === selectedHotel
    );

    console.log("Room Type Selected in Popup:", roomType); // Log room type selected
  
    const checkInData = {
      activity_type: editMode === "checkin" ? "checkin" : "checkout",
      city: selectedCity,
      hotel_name: selectedHotelData?.name || "", // Ensure hotel_name is passed
      hotel_id: selectedHotelData?.hotel_id || "", // Pass hotel_id as well
      mealPlan,
      inclusion,
      arrangement,
      roomType, // Include room type in check-in/check-out data
    };
     console.log("Check-in Data:", checkInData); 
    
    onAdd(checkInData);
    onClose();
    
  };

  console.log("Selected Room Category:", selectedRoomCategory);
console.log("Room Type:", roomType);





  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
    <div
      className="bg-white rounded-lg p-6 shadow-lg w-1/2 max-h-[90vh] overflow-y-auto"
    >
        <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">{popupTitle}</h2>

  <button onClick={onClose} className="text-gray-600 hover:text-black">
    ✖
  </button>
</div>


        <div className="space-y-4">
          {/* City Dropdown */}
          <div>
            <label className="block text-sm font-medium mb-2">City:</label>
            {isLoadingCities ? (
              <p>Loading cities...</p>
            ) : (
              <select
                className="w-full p-2 border rounded"
                value={selectedCity}
                onChange={(e) => setSelectedCity(e.target.value)}
              >
                <option value="">-- Select City --</option>
                {availableCities.map((city) => (
                  <option key={city.id} value={city.city_name}>
                    {city.city_name}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div>
  <label className="block text-sm font-medium mb-2">Hotel:</label>
  {isLoadingHotels ? (
    <p>Loading hotels...</p>
  ) : (
    <select
      className="w-full p-2 border rounded  "
      value={selectedHotel} // Use selectedHotel from state
      onChange={(e) => handleHotelSelect(e.target.value)} // Call the new handler
      disabled={!selectedCity}
    >
      <option value="">-- Select Hotel --</option>
      {availableHotels.map((hotel) => (
        <option key={hotel.hotel_id} value={hotel.name}>
          {hotel.name}
        </option>
      ))}
    </select>
  )}
</div>

{/* Room Type Dropdown */}
<div>
  <label className="block text-sm font-medium mb-2">Room Type:</label>
  <select
  className="w-full p-2 border rounded"
  value={roomType}
  onChange={(e) => {
    setRoomType(e.target.value);
    console.log("Selected Room Type:", e.target.value);
  }}
  disabled={!selectedHotel}
>
  <option value="">-- Select Room Type --</option>
  {roomTypes.map((type, index) => (
    <option key={index} value={type}>
      {type}
    </option>
  ))}
</select>


</div>





 {/* Meal Plan Buttons */}
<div>
  <label className="block text-sm font-medium mb-2">Meal Plan:</label>
  <div className="flex gap-2">
    {mealPlans.length > 0 ? (
      mealPlans.map((plan, index) => (
        <button
          key={index}
          className={`px-4 py-2 rounded border ${
            mealPlan === plan
              ? "bg-blue-500 text-white" // Highlight selected meal plan
              : "bg-gray-100 text-gray-700"
          }`}
          onClick={() => setMealPlan(plan)} // Set the selected meal plan
        >
          {plan}
        </button>
      ))
    ) : (
      <p className="text-sm text-gray-500">No meal plans available.</p>
    )}
  </div>
</div>




          {/* Inclusion/Exclusion Buttons */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Inclusion/Exclusion:
            </label>
            <div className="flex gap-2">
              <button
                className={`px-4 py-2 rounded border ${
                  inclusion
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-gray-700"
                }`}
                onClick={() => setInclusion(true)}
              >
                Inclusion
              </button>
              <button
                className={`px-4 py-2 rounded border ${
                  !inclusion
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-gray-700"
                }`}
                onClick={() => setInclusion(false)}
              >
                Exclusion
              </button>
            </div>
          </div>

          {/* Arrangement Type Buttons */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Arrangement:
            </label>
            <div className="flex gap-2">
              <button
                className={`px-4 py-2 rounded border ${
                  arrangement === "Company Arrangement"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-gray-700"
                }`}
                onClick={() => setArrangement("Company Arrangement")}
              >
                Company Arrangement
              </button>
              <button
                className={`px-4 py-2 rounded border ${
                  arrangement === "Own Arrangement"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-gray-700"
                }`}
                onClick={() => setArrangement("Own Arrangement")}
              >
                Own Arrangement
              </button>
            </div>
          </div>
        </div>

   {/* Action Buttons */} 
<div className="mt-8 flex justify-between gap-4 ">
  <button
    onClick={() => {
      // Check if the selectedRoomCategory is part of roomTypes
      const validRoomType = roomTypes.includes(roomType) ? roomType : selectedRoomCategory;

      const checkInData = {
        activity_type: "checkin",
        city: selectedCity,
        hotel_name: selectedHotel,
        hotel_id: availableHotels.find(
          (hotel) => hotel.name === selectedHotel
        )?.hotel_id || "",
        mealPlan,
        inclusion,
        arrangement,
        roomType: validRoomType, // Always pass the selected room type
      };
      onAdd(checkInData);
      onClose();
      
    }}
    className={`px-4 py-2 rounded w-1/2 ${
      editMode === "checkout" ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"
    }`}
    disabled={editMode === "checkout"} // Disable if in "checkout" edit mode
  >
    Check-in {/* Display Room Type for Check-in */}
  </button>

  <button
    onClick={() => {
      // Check if the selectedRoomCategory is part of roomTypes
      const validRoomType = roomTypes.includes(selectedRoomCategory) ? selectedRoomCategory : roomType;

      const checkOutData = {
        activity_type: "checkout",
        city: selectedCity,
        hotel_name: selectedHotel,
        hotel_id: availableHotels.find(
          (hotel) => hotel.name === selectedHotel
        )?.hotel_id || "",
        mealPlan,
        arrangement,
        inclusion,
        roomType: validRoomType, // Use validRoomType if it's part of roomTypes
      };
      onAdd(checkOutData);
      onClose();
    }}
    className={`px-4 py-2 rounded w-1/2 ${
      editMode === "checkin" ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"
    }`}
    disabled={editMode === "checkin"} // Disable if in "checkin" edit mode
  >
    Check-out {/* Display Room Type for Check-out */}
  </button>
</div>

      </div>
    </div>
  );
};

export default CheckInCheckOutPopup;